import React from 'react';
import { MessageSquare, Globe, Zap, ChefHat } from 'lucide-react';

const Features = ({ language }) => {
  const texts = {
    en: {
      title: 'What you get',
      subtitle: 'Access to games for the duration of your subscription.',
      features: [
        {
          icon: MessageSquare,
          title: 'Reply with JA',
          description: 'Enter your number and reply with JA (for Salt and Sunrise) to activate.',
        },
        {
          icon: ChefHat,
          title: 'Play & download games',
          description: 'All provided games to play and download for the subscription period.',
        },
        {
          icon: Zap,
          title: 'CHF 10 per week',
          description: '2 SMS per week for Salt, 1 SMS per week for Sunrise.',
        },
        {
          icon: Globe,
          title: 'Salt & Sunrise',
          description: 'Built for Switzerland. Works with Salt and Sunrise.',
        },
      ],
    },
    de: {
      title: 'Was du bekommst',
      subtitle: 'Zugang zu Spielen für die Dauer deines Abos.',
      features: [
        {
          icon: MessageSquare,
          title: 'Mit JA antworten',
          description: 'Nummer eingeben und mit JA antworten (für Salt und Sunrise) zum Aktivieren.',
        },
        {
          icon: ChefHat,
          title: 'Spiele spielen & herunterladen',
          description: 'Alle bereitgestellten Spiele für die Abo-Dauer spielen und herunterladen.',
        },
        {
          icon: Zap,
          title: 'CHF 10 pro Woche',
          description: '2 SMS/Woche für Salt, 1 SMS/Woche für Sunrise.',
        },
        {
          icon: Globe,
          title: 'Salt & Sunrise',
          description: 'Für die Schweiz. Funktioniert mit Salt und Sunrise.',
        },
      ],
    },
  };

  const t = texts[language];

  return (
    <section id="section-2" className="py-20 px-4 sm:px-6 lg:px-8 bg-slate-900/50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-heading font-bold text-white mb-4">
            {t.title}
          </h2>
          <p className="text-slate-400 text-lg max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 rounded-2xl bg-slate-800/50 border border-slate-700/50 hover:border-brand-500/30 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-brand-500/20 flex items-center justify-center mb-4 group-hover:bg-brand-500/30 transition-colors">
                <feature.icon className="w-6 h-6 text-brand-400" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-white mb-2">
                {feature.title}
              </h3>
              <p className="text-slate-400 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 flex justify-center">
          <div className="relative rounded-2xl overflow-hidden border border-slate-700/50 max-w-2xl w-full aspect-video bg-slate-800/50">
            <img
              src="/images/features.jpeg"
              alt="ChefSmarter features"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
